import { render, staticRenderFns } from "./PaymentsAndCoupons.vue?vue&type=template&id=679ba9a8"
import script from "./PaymentsAndCoupons.vue?vue&type=script&lang=js"
export * from "./PaymentsAndCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports